const COLORS: Record<string, string> = {
  priced: "bg-green-700/30 text-green-300",
  pricing: "bg-yellow-700/30 text-yellow-300",
  no_comps: "bg-zinc-700/40 text-zinc-300",
  extraction_failed: "bg-red-700/30 text-red-300",
  // lister session statuses
  scanned: "bg-zinc-700/40 text-zinc-300",
  researching: "bg-zinc-700/40 text-zinc-300",
  researched: "bg-zinc-700/40 text-zinc-300",
  proposing: "bg-zinc-700/40 text-zinc-300",
  proposed: "bg-blue-700/30 text-blue-300",
  posting: "bg-yellow-700/30 text-yellow-300",
  posted: "bg-green-700/30 text-green-300",
  restocked: "bg-green-700/30 text-green-300",
  failed: "bg-red-700/30 text-red-300",
};

export default function StatusPill({ status }: { status: string }) {
  return (
    <span className={`text-xs font-mono px-2 py-0.5 rounded ${COLORS[status] ?? "bg-zinc-800 text-zinc-400"}`}>
      {status}
    </span>
  );
}
